import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from 'react';

const NumericEditor = forwardRef((props, ref) => {

  const [value, setValue] = useState(parseFloat(props.value));
  const refInput = useRef(null);

  useEffect(() => {
    refInput.current.focus();
  });

  useImperativeHandle(ref, () => ({
    getValue: () => value,
    isCancelBeforeStart: () => false,
    isCancelAfterEnd: () => false,
  }));

  return (
    <input
      ref={refInput}
      defaultValue={value}
      onChange={event => {
        setValue(parseFloat(event.target.value));
      }}
      style={{width: "100%"}}
    />
  );

});

export default NumericEditor;
